import { useState } from "react";
import { EmailUrl } from "../constants";

const useSendEmail = () => {
  const [userEmail, setUserEmail] = useState("");

  const addUserEmail = (email) => {
    setUserEmail(email);
  };

  const sendEmail = (language, countryCode, apiToken) => {
    if (userEmail === "") return;

    try {
      fetch(`${EmailUrl}?lng=${language}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apiToken,
        },
        body: JSON.stringify({ email: userEmail, country_code: countryCode }),
      });
    } catch (error) {}
  };

  return { addUserEmail, sendEmail };
};

export default useSendEmail;
